export default {"src":"/_next/static/media/FLT.e37a8175.svg","height":18,"width":18};